var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, forwardRef, useRef, useImperativeHandle, useCallback, useMemo } from 'react';
import { usePatchElement } from '../hooks';
import { ModalAlertAPI } from '../ModalAlert';
import { ModalConfirmAPI } from '../ModalConfirm';
var ElementsHolder = memo(forwardRef(function (_props, ref) {
    var _a = usePatchElement(), elements = _a[0], patchElement = _a[1];
    useImperativeHandle(ref, function () { return ({ patchElement: patchElement }); }, [patchElement]);
    return React.createElement(React.Fragment, null, elements);
}));
var uuid = 0;
export function useModal() {
    var holderRef = useRef(null);
    var alert = useCallback(function (options) {
        return new Promise(function (resolve) {
            var _a;
            if (typeof options === 'string') {
                options = { message: options };
            }
            var cleanup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(React.createElement(ModalAlertAPI, __assign({ key: "modal-".concat(++uuid) }, options, { onOk: function () { return resolve(); }, onExited: function () { return cleanup === null || cleanup === void 0 ? void 0 : cleanup(); } })));
        });
    }, []);
    var confirm = useCallback(function (options) {
        return new Promise(function (resolve) {
            var _a;
            var cleanup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(React.createElement(ModalConfirmAPI, __assign({ key: "modal-".concat(++uuid) }, options, { onOk: function () { return resolve(true); }, onCancel: function () { return resolve(false); }, onExited: function () { return cleanup === null || cleanup === void 0 ? void 0 : cleanup(); } })));
        });
    }, []);
    return [
        useMemo(function () { return ({ alert: alert, confirm: confirm }); }, [alert, confirm]),
        React.createElement(React.Fragment, null,
            React.createElement(ElementsHolder, { ref: holderRef })),
    ];
}
